import { useState, useEffect, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import { GetSimpleSpecPackTrimLevel_specPacks } from '../../trimLevels/graphql/queries/__generated__/GetSimpleSpecPackTrimLevel';

const useFilterTabs = (specPacks: GetSimpleSpecPackTrimLevel_specPacks[]) => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const marketingCategories: string[] = [...new Set(specPacks?.map(spc => spc.specPack.attributes.marketingcategory))];

  const [currentFilter, setCurrentFilter] = useState<string>();

  const onFilterTabNavigate = useCallback(
    (value: string) => {
      if (value) {
        setCurrentFilter(value);
        queryParams.marketingCategory = value;
        history.push({ search: queryString.stringify(queryParams) });
      }
    },
    [queryParams, history],
  );

  const filteredDataTabs = useMemo(() => {
    if (currentFilter) {
      return specPacks?.filter(spc => spc.specPack.attributes.marketingcategory === currentFilter) || [];
    }

    return [];
  }, [specPacks, currentFilter]);

  useEffect(() => {
    // Set currentFilter on load
    if (!currentFilter && marketingCategories[0] && marketingCategories.length > 1) {
      const { marketingCategory } = queryParams;
      onFilterTabNavigate(marketingCategory ? marketingCategory.toString() : marketingCategories[0]);
    }
  }, [marketingCategories, currentFilter, queryParams, onFilterTabNavigate]);

  useEffect(() => {
    // Handle browser back/forward
    const queryParams = queryString.parse(location.search);
    const { marketingCategory } = queryParams;
    if (marketingCategory && currentFilter && queryParams.marketingCategory !== currentFilter) {
      onFilterTabNavigate(marketingCategory.toString());
    }
  }, [currentFilter, location, onFilterTabNavigate]);

  return {
    currentFilter,
    onFilterTabNavigate,
    marketingCategories,
    filteredDataTabs: marketingCategories.length > 1 ? filteredDataTabs : specPacks,
  };
};

export default useFilterTabs;
